import {
  fetchCollection
} from './index'

import { userSchema } from '../schemas'

export const TECHNICIANS_REQUEST = 'TECHNICIANS_REQUEST'
export const TECHNICIANS_SUCCESS = 'TECHNICIANS_SUCCESS'
export const TECHNICIANS_FAILURE = 'TECHNICIANS_FAILURE'

export function fetchTechniciansForLocation (id, query = null) {
  return fetchCollection({
    url: `/locations/${id}/technicians`,
    key: 'technicians',
    schema: userSchema,
    actions: [ TECHNICIANS_REQUEST, TECHNICIANS_SUCCESS, TECHNICIANS_FAILURE ],
    query
  })
}

export function fetchTechniciansForLocationWithAllocation (locationId, { startsAt, endsAt }) {
  if (startsAt) { startsAt = startsAt.toISOString() }
  if (endsAt) { endsAt = endsAt.toISOString() }

  return (dispatch, getState) => {
    return dispatch(fetchTechniciansForLocation(locationId, { startsAt, endsAt }))
  }
}

export function fetchTechniciansForCurrentLocationWithAllocation (id) {
  return (dispatch, getState) => {
    let { location, startsAt, endsAt } = getState().workOrders[id]
    if (startsAt) { startsAt = startsAt.toISOString() }
    if (endsAt) { endsAt = endsAt.toISOString() }

    return dispatch(fetchTechniciansForLocation(location, { startsAt, endsAt }))
  }
}

export function fetchTechniciansForWorkOrder (id) {
  return (dispatch, getState) => {
    const locationId = getState().workOrders[id].location
    return dispatch(fetchTechniciansForLocation(locationId))
  }
}

export const TECHNICIANS_ALLOCATED_TO_WORK_ORDER_REQUEST = 'TECHNICIANS_ALLOCATED_TO_WORK_ORDER_REQUEST'
export const TECHNICIANS_ALLOCATED_TO_WORK_ORDER_SUCCESS = 'TECHNICIANS_ALLOCATED_TO_WORK_ORDER_SUCCESS'
export const TECHNICIANS_ALLOCATED_TO_WORK_ORDER_FAILURE = 'TECHNICIANS_ALLOCATED_TO_WORK_ORDER_FAILURE'

export function fetchTechniciansAllocatedToWorkOrder (workOrderId) {
  return fetchCollection({
    url: `/work_orders/${workOrderId}/technicians`,
    key: 'technicians',
    schema: userSchema,
    actions: [
      TECHNICIANS_ALLOCATED_TO_WORK_ORDER_REQUEST,
      TECHNICIANS_ALLOCATED_TO_WORK_ORDER_SUCCESS,
      TECHNICIANS_ALLOCATED_TO_WORK_ORDER_FAILURE
    ],
    responseInterceptor: response => ({ ...response, workOrderId })
  })
}



// WEBPACK FOOTER //
// ./src/actions/technicians.js